import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

export const createBatch = async (payload) => {
  const response = await fetch(`${API_URL}/api/batches`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    throw new Error("Failed to create batch");
  }

  return await response.json(); // Yeh response me batch ka _id hoga
};

export const fetchBatches = async (page, pageSize) => {
  try {
    console.log("API_URL: ", API_URL)
    // The API reads `pageSize`, not `limit` — sending the wrong name silently
    // capped every caller at the default 10 batches.
    const res = await fetch(`${API_URL}/api/batches?page=${page || 1}&pageSize=${pageSize || 500}`);
    const response = await res.json();

    // ✅ Return full response object including pagination
    return {
      data: response.data,
      pagination: response.pagination,
    };
  } catch (error) {
    throw error;
  }
};
export const fetchBatchById = async (id) => {
  try {
    const response = await axios.get(`${API_URL}/api/batches/${id}`);
    return response.data.data;
  } catch (error) {
    throw error;
  }
};

